import React from 'react';

import {FilteredCartListConnected} from '../filteredCartList/filteredCartList';
import {NewCartAccessoriesConnected} from '../newCartAccessories/newCartAccessories';

/**
 * Сart main container
 * @returns {React.ReactElement} - Container component
 */
export const CartMainSection: React.FC = () => {
    return (
        <main>
            <FilteredCartListConnected />
            <NewCartAccessoriesConnected />
        </main>
    );
};
